// extracted by mini-css-extract-plugin
export var chevron = "_dv-4";
export var chevronExpanded = "_dv-5";
export var row = "_dv-0";
export var rowBody = "_dv-6";
export var rowDescription = "_dv-7";
export var rowHeader = "_dv-1";
export var rowTitle = "_dv-2";
export var rowTitleComplete = "_dv-3";